import _get from 'lodash/get';
import { createStringComparator } from './sort';

const ascendingStringComparator = createStringComparator();

export const NOP = () => undefined;

export const hasValue = value => value != null && value !== '';

export function getHashcode(obj) {
  let hashcode = '';
  if (typeof obj !== 'object') {
    return hashcode + obj;
  }
  Object.keys(obj)
    .sort(ascendingStringComparator)
    .forEach(key => {
      hashcode += key + getHashcode(obj[key]);
    });
  return hashcode;
}

export function ttlCache(timeToLive) {
  const cache = [];
  const result = function ttlCache() {};
  result.push = data => {
    cache.push({ timestamp: Date.now(), data });
    while (cache.length > 0 && Date.now() - cache[0].timestamp > timeToLive) {
      cache.splice(0, 1);
    }
  };
  result.pop = () => {
    if (cache.length > 0) {
      return cache.splice(0, 1).data;
    }
  };
  result.popAll = () => {
    return cache.splice(0, cache.length).map(entry => entry.data);
  };
  result.peekAll = () => {
    return cache.map(entry => entry.data);
  };
  return result;
}

export function template(input) {
  const pattern = /\$\{([\wöäü\-_.]+?)\}/gi;
  return function generateOutput(scope = {}) {
    return input.replace(pattern, function replacer(_, key) {
      return _get(scope, key, '');
    });
  };
}

export function detachPromise() {
  let resolve = () => {
    throw new Error('There is no promise subscription');
  };
  let reject = resolve;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return {
    promise,
    resolve: (...args) => resolve(...args),
    reject: (...args) => reject(...args),
  };
}
